import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from '@mui/material/styles';

import { PageLoader, PageLoaderWrapper } from 'shared-components/Loaders';
import { persistor, store } from 'store';
import App from 'App';
import reportWebVitals from 'reportWebVitals';

import './index.css';
import { theme } from 'theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider
      theme={theme}>
      <Suspense
        fallback={
          <PageLoaderWrapper>
            <PageLoader />
          </PageLoaderWrapper>
        }><Provider
          store={store}>
          <PersistGate
            loading={null} persistor={persistor}>
            
            <App />
          </PersistGate>
        </Provider>
      </Suspense>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
